export default "__VITE_ASSET__EtDGa9Ix__"